import React from 'react';
import { Button } from 'components';
import { ArrowLeftIcon } from 'components/common/icons/ArrowLeftIcon';
import styles from './styles.module.scss';

interface ProgressStepperProps {
  currentStep: number;
  totalSteps: number;
  completedCount: number;
  totalCount: number;
  onBack?: () => void;
  showBackButton?: boolean;
}

export const ProgressStepper: React.FC<ProgressStepperProps> = ({
  currentStep,
  totalSteps,
  onBack,
  showBackButton = true,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        {showBackButton && onBack && (
          <Button type="text" onClick={onBack} className={styles.backButton} icon={<ArrowLeftIcon />} />
        )}

        <div className={styles.stepperContainer}>
          {Array.from({ length: totalSteps }).map((_, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;

            return (
              <React.Fragment key={stepNumber}>
                {stepNumber <= totalSteps && (
                  <div className={`${styles.stepLine} ${isActive || isCompleted ? styles.completed : ''}`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
